import { Outlet, useParams } from 'react-router-dom'
import useSWR from 'swr'

import Tabs from '@/components/Tabs'
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar'
import { Badge } from '@/components/ui/badge'
import { RotateBotToken } from './IssueBot'
import BotProfileDialog from './BotProfile'

const TabItems = [
  { name: 'Home', to: '', end: true },
  { name: 'Revenue', to: 'revenue' },
  { name: 'Roas', to: 'roas' },
  { name: 'Cost', to: 'cost' },
  { name: 'Camproi', to: 'camproi' },
  { name: 'ER', to: 'pr' },
  { name: 'Admob', to: 'admob' },
  { name: 'PAM 只读', to: 'pam' },
  { name: 'Roles', to: 'roles' },
]

const Index = () => {
  const { id: userId } = useParams()
  const { data: user } = useSWR([`/users/${userId}/full`])
  const isBot = user?.kind === 'bot'

  return (
    <div className="flex flex-col gap-4">
      {user && (
        <div className="flex flex-wrap items-center gap-4 rounded-md border p-4">
          <Avatar className="h-14 w-14">
            <AvatarImage src={user.avatarThumb} alt="" />
            <AvatarFallback>{isBot ? 'BOT' : 'OM'}</AvatarFallback>
          </Avatar>
          <div className="grid gap-1">
            <p className="flex items-center gap-2 text-lg font-semibold leading-none">
              {user.name}
              {isBot && <Badge variant="secondary">bot</Badge>}
            </p>
            <p className="text-sm text-muted-foreground">
              {user.id}
              {user.email ? ` · ${user.email}` : ''}
            </p>
            <p className="text-xs text-muted-foreground">
              角色：{user.roles?.filter(Boolean).join(', ') || '无'}
            </p>
          </div>
          {isBot && (
            <div className="ml-auto flex flex-wrap items-center gap-2">
              <BotProfileDialog bot={user} />
              <RotateBotToken bot={user} />
            </div>
          )}
        </div>
      )}
      <Tabs datas={TabItems} />
      <Outlet />
    </div>
  )
}

export default Index
